/**
 * Preview competitor brands on the Market Intelligence upsell screen.
 * Edit this file to change logos/names per sector without touching UI code.
 *
 * Each entry: { name, logoUrl? }
 * - logoUrl: optional absolute URL; when omitted the brand name is shown as text.
 * - Industry keys match Topic Library model_name (lowercase), e.g. "travel", "telecom".
 */
const TATILBUDUR_LOGO =
  "https://logowik.com/content/uploads/images/tatil-budur221.logowik.com.webp";

const CANONICAL_BRAND_LOGOS = {
  tatilbudur: TATILBUDUR_LOGO,
  "tatil budur": TATILBUDUR_LOGO,
};

export function resolveBrandLogoUrl(brand) {
  const url = String(brand?.logoUrl || "").trim();
  if (url) return url;
  const name = String(brand?.name || "").trim().toLowerCase();
  return CANONICAL_BRAND_LOGOS[name] || null;
}

export const MARKET_INTELLIGENCE_PREVIEW = {
  maxVisible: 6,
  default: [
    { name: "Vodafone" },
    { name: "Samsung" },
    { name: "Allianz" },
    { name: "Karaca" },
    { name: "Papara" },
    { name: "Millenicom" },
  ],
  byIndustry: {
    travel: [
      { name: "Booking.com" },
      { name: "Trivago" },
      { name: "Jolly Tur" },
      { name: "Setur" },
      { name: "Tatilbudur", logoUrl: TATILBUDUR_LOGO },
      { name: "Enuygun" },
    ],
    hospitality: [
      { name: "Booking.com" },
      { name: "Trivago" },
      { name: "Jolly Tur" },
      { name: "Setur" },
      { name: "Tatilbudur", logoUrl: TATILBUDUR_LOGO },
      { name: "Enuygun" },
    ],
    telecom: [
      { name: "Turkcell" },
      { name: "Türk Telekom" },
      { name: "Vodafone" },
      { name: "BİMcell" },
      { name: "Netflix" },
      { name: "Spotify" },
    ],
    telecommunications: [
      { name: "Turkcell" },
      { name: "Türk Telekom" },
      { name: "Vodafone" },
      { name: "BİMcell" },
      { name: "Netflix" },
      { name: "Spotify" },
    ],
    retail: [
      { name: "Trendyol" },
      { name: "Hepsiburada" },
      { name: "Amazon" },
      { name: "Zara" },
      { name: "Mango" },
      { name: "LC Waikiki" },
    ],
    "e-commerce": [
      { name: "Trendyol" },
      { name: "Hepsiburada" },
      { name: "Amazon" },
      { name: "n11" },
      { name: "GittiGidiyor" },
      { name: "Çiçeksepeti" },
    ],
    banking: [
      { name: "Akbank" },
      { name: "Garanti BBVA" },
      { name: "İş Bankası" },
      { name: "Yapı Kredi" },
      { name: "QNB" },
      { name: "Denizbank" },
    ],
    insurance: [
      { name: "Allianz" },
      { name: "Axa" },
      { name: "Anadolu Sigorta" },
      { name: "Mapfre" },
      { name: "Generali" },
      { name: "Zurich" },
    ],
    fintech: [
      { name: "Papara" },
      { name: "Param" },
      { name: "Paycell" },
      { name: "Tosla" },
      { name: "Ininal" },
      { name: "Revolut" },
    ],
    automotive: [
      { name: "Toyota" },
      { name: "Volkswagen" },
      { name: "Renault" },
      { name: "Ford" },
      { name: "Hyundai" },
      { name: "Tesla" },
    ],
  },
};

export function resolveMarketIntelligencePreviewBrands(industryKey) {
  const key = String(industryKey || "").trim().toLowerCase();
  const configured =
    (key && MARKET_INTELLIGENCE_PREVIEW.byIndustry[key]) ||
    MARKET_INTELLIGENCE_PREVIEW.default;
  const limit = MARKET_INTELLIGENCE_PREVIEW.maxVisible || 6;
  return configured.slice(0, limit);
}
